export const faqPageContent = {
  title: `Witamy w sekcji FAQ`,
  description: `Przygotowaliśmy odpowiedzi na najczęściej zadawane pytania dotyczące
        umawiania wizyt, przeglądów bezpieczeństwa instalacji elektrycznych,
        gazowych i alarmów przeciwpożarowych, a także modernizacji tablic
        rozdzielczych. Naszym celem jest przekazanie jasnych i konkretnych
        informacji, aby ułatwić Ci zrozumienie tych usług i podjęcie świadomych
        decyzji zgodnie z obowiązującymi w Polsce przepisami prawa budowlanego i
        bezpieczeństwa.`,
  note: `Powyższe odpowiedzi mają charakter ogólny i dotyczą kluczowych zasad
          bezpieczeństwa wynikających z polskiego prawa budowlanego, przepisów
          przeciwpożarowych oraz norm dotyczących instalacji elektrycznych i
          gazowych w budynkach mieszkalnych.`,
  seo: {
    title: `Najczęściej Zadawane Pytania`,
    description: `Odpowiedzi na najczęstsze pytania dotyczące naszych usług: przeglądy bezpieczeństwa, modernizacje instalacji wodno-kanalizacyjnych i rozdzielnic.`,
  },
};
